import {Color} from '@benchling/nucleus-ui';

import {AntibodyChainType, AntibodyDomainType} from 'graphql-client/__generated/graphqlGlobalTypes';

export const CONNECTOR_DOMAIN_COLOR = Color.BLACK;

export const DEEMPHASIZED_DOMAIN_OPACITY = 0.4;

interface ColorsForChain {
  chainColor: string;
  variableDomainColor: string;
  constantDomainColor: string;
}

export const CONSTANT_DOMAIN_LABEL_COLOR = Color.GRAY_900;
export const VARIABLE_DOMAIN_LABEL_COLOR = Color.WHITE;

export const COLORS_BY_CHAIN_INDEX: Array<ColorsForChain> = [
  {
    chainColor: '#007FB5',
    variableDomainColor: '#005B82',
    constantDomainColor: '#C2EAFB',
  },
  {
    chainColor: '#8DB800',
    variableDomainColor: '#5F7B00',
    constantDomainColor: '#EAFDAA',
  },
  {
    chainColor: '#BB3E03',
    variableDomainColor: '#9C3402',
    constantDomainColor: '#DD9E81',
  },
  {
    chainColor: '#B5006D',
    variableDomainColor: '#82004E',
    constantDomainColor: '#FBC2E4',
  },
  {
    chainColor: '#00823D',
    variableDomainColor: '#005126',
    constantDomainColor: '#C2FBDD',
  },
  {
    chainColor: '#CA7D49',
    variableDomainColor: '#98582C',
    constantDomainColor: '#C2A693',
  },
  {
    chainColor: '#9A4BD7',
    variableDomainColor: '#6500B5',
    constantDomainColor: '#E2C2FB',
  },
  {
    chainColor: '#2C55E7',
    variableDomainColor: '#000DB5',
    constantDomainColor: '#B2C3FF',
  },
  {
    chainColor: '#CD6672',
    variableDomainColor: '#B23A48',
    constantDomainColor: '#D89CA3',
  },
  {
    chainColor: '#624686',
    variableDomainColor: '#3D2C54',
    constantDomainColor: '#ABA4B8',
  },
];

export const FRIENDLY_NAMES_BY_DOMAIN_TYPE: Record<AntibodyDomainType, string> = {
  [AntibodyDomainType.VL]: 'Variable light',
  [AntibodyDomainType.CL]: 'Constant light',
  [AntibodyDomainType.VH]: 'Variable heavy',
  [AntibodyDomainType.VHH]: 'Single-domain variable heavy',
  [AntibodyDomainType.CH1]: 'Constant heavy 1',
  [AntibodyDomainType.CH2]: 'Constant heavy 2',
  [AntibodyDomainType.CH3]: 'Constant heavy 3',
  [AntibodyDomainType.CH4]: 'Constant heavy 4',
  [AntibodyDomainType.J]: 'Joiner',
  [AntibodyDomainType.H]: 'Hinge',
  [AntibodyDomainType.L]: 'Linker',
  [AntibodyDomainType.VA]: 'Variable alpha',
  [AntibodyDomainType.CA]: 'Constant alpha',
  [AntibodyDomainType.VB]: 'Variable beta',
  [AntibodyDomainType.CB]: 'Constant beta',
  [AntibodyDomainType.VG]: 'Variable gamma',
  [AntibodyDomainType.CG]: 'Constant gamma',
  [AntibodyDomainType.VD]: 'Variable delta',
  [AntibodyDomainType.CD]: 'Constant delta',
};

export const FRIENDLY_NAMES_BY_CHAIN_TYPE: Record<AntibodyChainType, string> = {
  [AntibodyChainType.HEAVY]: 'Heavy chain',
  [AntibodyChainType.LIGHT]: 'Light chain',
  [AntibodyChainType.SINGLE]: 'Single chain',
  [AntibodyChainType.ALPHA]: 'TCR alpha',
  [AntibodyChainType.BETA]: 'TCR beta',
};

export const ANTIBODY_CONSTANT_DOMAIN_TYPES = [
  AntibodyDomainType.CA,
  AntibodyDomainType.CB,
  AntibodyDomainType.CD,
  AntibodyDomainType.CG,
  AntibodyDomainType.CH1,
  AntibodyDomainType.CH2,
  AntibodyDomainType.CH3,
  AntibodyDomainType.CH4,
  AntibodyDomainType.CL,
  AntibodyDomainType.H,
  AntibodyDomainType.J,
  AntibodyDomainType.L,
];

export enum AntibodyComponentType {
  AA_DOMAIN = 'AA_DOMAIN',
  DNA_DOMAIN = 'DNA_DOMAIN',
  AA_CHAIN = 'AA_CHAIN',
  DNA_CHAIN = 'DNA_CHAIN',
  AA_PAIR = 'AA_PAIR',
  DNA_PAIR = 'DNA_PAIR',
  ANTIGEN = 'ANTIGEN',
}
